// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"a60937fa","408":"152de6bb","917":"d50d1b0b"}[chunkId] + ".chunk.js";
};